import type { User } from '@supabase/supabase-js';
import { atom, computed } from 'nanostores';

export const PROFIL_BASE_URL = 'https://localhost:3000/object-filter/';
export const PROFIL_RESET_PASSWORD_URL =
	'https://localhost:3000/object-filter/';

export const $supabaseUser = atom< User | null >( null );
export const $authReady = atom( false );

// Auth state is written exclusively by the central auth-init module
// (src/scripts/lib/supabase/authInit.ts), which owns the single
// onAuthStateChange subscription.

export const $isLoggedIn = computed( $supabaseUser, ( user ) => !! user );
